var $ = require('../internals/export');
var hasOwn = require('../internals/has-own-property');

// `Object.hasOwn` method
// https://github.com/tc39/proposal-accessible-object-hasownproperty
$({ target: 'Object', stat: true }, {
  hasOwn: hasOwn
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.object.has-own.js
// module id = 353
// module chunks = 0